// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file shifts/end_shift.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.EndShiftRequest
 */
export class EndShiftRequest extends Message<EndShiftRequest> {
  /**
   * @generated from field: int32 end_time = 1;
   */
  endTime = 0;

  /**
   * @generated from field: float cash_drawer_end_amount = 2;
   */
  cashDrawerEndAmount = 0;

  /**
   * @generated from field: float card_end_amount = 3;
   */
  cardEndAmount = 0;

  /**
   * @generated from field: float payouts = 4;
   */
  payouts = 0;

  constructor(data?: PartialMessage<EndShiftRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.EndShiftRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "end_time", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "cash_drawer_end_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "card_end_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "payouts", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EndShiftRequest {
    return new EndShiftRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EndShiftRequest {
    return new EndShiftRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EndShiftRequest {
    return new EndShiftRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EndShiftRequest | PlainMessage<EndShiftRequest> | undefined, b: EndShiftRequest | PlainMessage<EndShiftRequest> | undefined): boolean {
    return proto3.util.equals(EndShiftRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.EndShiftResponse
 */
export class EndShiftResponse extends Message<EndShiftResponse> {
  constructor(data?: PartialMessage<EndShiftResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.EndShiftResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EndShiftResponse {
    return new EndShiftResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EndShiftResponse {
    return new EndShiftResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EndShiftResponse {
    return new EndShiftResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EndShiftResponse | PlainMessage<EndShiftResponse> | undefined, b: EndShiftResponse | PlainMessage<EndShiftResponse> | undefined): boolean {
    return proto3.util.equals(EndShiftResponse, a, b);
  }
}

